import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseDialog } from '../../Dialog-types/base-dialog';
import { ButtonInfo, ValueAndDisplay } from '../../../UI-Components/helperClasses/value-and-display.class';
import { IValidator } from '../../../../Directives/directives.helper';
import { Validators } from '../../../Validators/validators';
import { SiteDefaultView, SiteWhenPlacemarksAreVisible } from '../../../../Store/sites.state/sites.utils';
import { CustomOKButton, EditorMode } from '../dialog.helper';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { AppState } from '../../../../Store/app.state/app.state';
import { DialogService } from 'src/app/services/dialogs.service';
import { ICompanyInfo, IntositeLoginMethod } from 'src/app/common/Models/UI/company-info.interface';
import { SessionApiSvc } from 'src/app/services/api.services/session.api.svc';
import { WebshareLoginApiSvc } from 'src/app/services/api.services/webshare.login.api.svc';
import { ApiTools } from 'src/app/services/api.services/api.tools';
import { ISite } from 'src/app/Store/sites.state/sites.model';
import { PointCloudSvc } from 'src/app/services/api.services/point-cloud.service';
import { PointCloudProvider, WebshareAuthType } from 'src/app/common/Models/UI/point-cloud.interface';
import { DraggableDirective } from '../../../../Directives/draggable.directive';
import { MatIcon } from '@angular/material/icon';
import { InputBoxComponent } from '../../../UI-Components/input-box/input-box.component';
import { MultilineBoxComponent } from '../../../UI-Components/multiline-box/multiline-box.component';
import { InputFileComponent } from '../../../UI-Components/input-file/input-file.component';
import { AsyncPipe } from '@angular/common';
import { SelectionBoxComponent } from '../../../UI-Components/selection-box/selection-box.component';
import { StateSliderComponent } from '../../../UI-Components/state-slider/state-slider.component';
import { CheckboxComponent } from '../../../UI-Components/checkbox/checkbox.component';
import { ExpansionBoxComponent } from '../../../UI-Components/expansion-box/expansion-box.component';
import { IAppConf } from 'src/app/Store/app.state/app.model';

@Component({
    selector: 'ins-new-edit-site',
    templateUrl: './new-edit-site.dialog.component.html',
    styleUrls: ['./new-edit-site.dialog.component.scss', './../shared-dialogs-ui.scss', './../../../UI-Components/shared-UI-components.scss'],
    imports: [DraggableDirective, MatIcon, InputBoxComponent, MultilineBoxComponent, InputFileComponent, SelectionBoxComponent, StateSliderComponent, CheckboxComponent, ExpansionBoxComponent]
})
export class NewEditSiteDialogComponent extends BaseDialog implements OnInit {

  valuesForDefaultView: ValueAndDisplay[] = [
    {value: SiteDefaultView.LastVisited , displayValue: 'Last Visited'},
    {value: SiteDefaultView.Maps , displayValue: 'Maps'},
    {value: SiteDefaultView.Facility , displayValue: 'Facility'},
  ];

  valuesForPlacemarkVisibility: ButtonInfo[] = [
    {value: SiteWhenPlacemarksAreVisible.Close, displayValue: 'Close'},
    {value: SiteWhenPlacemarksAreVisible.Intermediate, displayValue: 'Intermediate'},
    {value: SiteWhenPlacemarksAreVisible.Far, displayValue: 'Far'},
    {value: SiteWhenPlacemarksAreVisible.Always, displayValue: 'Always'}
  ];

  public companyInfo: ICompanyInfo = null;
  companyInfo$: Observable<ICompanyInfo>;
  public appConf: IAppConf;
  appConf$: Observable<IAppConf>;
  public pointCloudConfOptions: ButtonInfo[] = [];
  public selectedPointCloudConf: any;

  @Input() siteId: string;
  @Input() name: string;
  @Input() description: string;
  @Input() image: File;
  @Input() defaultView: SiteDefaultView = SiteDefaultView.LastVisited;
  @Input() placemarkLOD: SiteWhenPlacemarksAreVisible = SiteWhenPlacemarksAreVisible.Close;
  @Input() placemarkClustering: boolean = false;
  @Input() latitude: number = 0;
  @Input() longitude: number = 0;
  @Input() radiusForPlacemarks: number = 0;
  @Input() radiusForPano: number = 0;
  @Input() dialogMode: EditorMode = EditorMode.NEW;
  @Input() x_coord: string;
  @Input() y_coord: string;
  @Input() z_coord: string;
  @Input() pointCloudConfId: any;

  public buttonsInfo: ButtonInfo[] = [];
  public pointCloudAuthPending: boolean = false;
  public isPointCloudConfSelectEnabled: boolean = false;
  public disabledWSLoginMethod: string;

  validatorForPlacemarks: IValidator[] = [{objectID: 'info', regEx: '',
    displayText: 'Placemarks that are located within the radius will be displayed in the panoramic image.'}];
  validatorForPanoramic: IValidator[] = [{objectID: 'info', regEx: '',
    displayText: 'Other panoramic images that are located within the radius will be linked to the panoramic image.'}];
  fileTypeValidator: IValidator[] = [];
  validatorForDomainUrl: IValidator[] = [
    { objectID: 'info', regEx: '', displayText: 'Domain URL field is mandatory when API Key is defined'},
    { objectID: 'input', regEx: '^(http|https)://(.)+', displayText: 'Please provide a valid domain URL'}];

  constructor(public injector: Injector, public validators: Validators, public pointCloudSvc: PointCloudSvc, public dialogService: DialogService,
    public sessionApiSvc: SessionApiSvc, private readonly store: Store, public webshareLoginApiSvc: WebshareLoginApiSvc) {
    super(injector);
    this.appConf$ = this.store.select(AppState.getAppConf);
    this.appConf$.subscribe(info => this.appConf = info);
    this.companyInfo$ = this.store.select(AppState.getCompanyInfo);
    this.companyInfo$.subscribe(info => this.companyInfo = info);
    this.validatorForPlacemarks.push(validators.DigitsOnly);
    this.validatorForPlacemarks.push(validators.Required);
    this.validatorForPanoramic.push(validators.DigitsOnly);
    this.validatorForPanoramic.push(validators.Required);
    this.fileTypeValidator = [{objectID: 'input', displayText: 'File can be only image'},
      validators.Required];
  }

  ngOnInit(): void {
    this.buttonsInfo.push(
      new ButtonInfo('cancel', 'Cancel'),
      new ButtonInfo('add', CustomOKButton.get(this.dialogMode))
    );
    this.initializePointCloudConfOptions();
  }

  public defineDialogModel(): void {
    this.dialogModel.initModel(
      ['siteId', this.siteId],
      ['name', this.name],
      ['description', this.description],
      ['image', this.image],
      ['defaultView', this.defaultView],
      ['placemarkLOD', this.placemarkLOD],
      ['placemarkClustering', this.placemarkClustering],
      ['latitude', this.latitude, true],
      ['longitude', this.longitude, true],
      ['radiusForPlacemarks', this.radiusForPlacemarks],
      ['radiusForPano', this.radiusForPano],
      ['dialogMode', this.dialogMode],
      ['x_coord', this.x_coord],
      ['y_coord', this.y_coord],
      ['z_coord', this.z_coord],
      ['pointCloudConfId', this.pointCloudConfId]);
  }

  public async testPointCloudConnection(): Promise<void> {
    this.pointCloudAuthPending = true;
    try {
      await this.pointCloudSvc.testPointCloudConnection(this.selectedPointCloudConf);
    } catch (error) {
      console.error('Error during point cloud login:', error);
    } finally {
      this.pointCloudAuthPending = false;
    }
  }

  public isApplyDisabled(): boolean {
    return !this.isDialogValid || this.pointCloudAuthPending;
  }

  public changeWebshareConf(confId: number): void {
    this.selectedPointCloudConf = this.pointCloudSvc.getPointCloudConfById(confId);
  }

  public showPointCloudTestCon(): boolean {
    return this.pointCloudSvc.showTestPointCloudConnection(this.selectedPointCloudConf) && !this.pointCloudAuthPending;
  }

  public closeDialog(param: any): void {
    this.pointCloudSvc.cancelCheckConnection();
    this.close(param);
  }

  public addUpdateSite(param: any): void {
    if (this.siteId && ApiTools.defaultSiteId && this.siteId == ApiTools.defaultSiteId) {
      const activeSite: ISite = this.store.selectSnapshot<ISite>((state: any) => state.StateApp.activeSite );
      if (activeSite.pointCloudConfId != this.pointCloudConfId) {
        this.pointCloudSvc.clearPointCloudSession();
      }
    }
    this.close(param);
  }

  public initializePointCloudConfOptions(): void {
    this.pointCloudConfOptions = this.pointCloudSvc.getPointCloudConfsSelectionOpts();
    this.selectedPointCloudConf = this.pointCloudSvc.getPointCloudConfById(this.pointCloudConfId);
    if (this.pointCloudSvc.pointCloudProvider == PointCloudProvider.SphereXG) {
      this.isPointCloudConfSelectEnabled = true;
    } else if (this.pointCloudSvc.pointCloudProvider == PointCloudProvider.Webshare) {
      if (this.selectedPointCloudConf) {
        if (this.selectedPointCloudConf.loginMethod == WebshareAuthType.Enterprise && this.companyInfo.intositeLoginMethod != IntositeLoginMethod.Enterprise) {
          this.isPointCloudConfSelectEnabled = false;
          this.disabledWSLoginMethod = WebshareAuthType.Enterprise;
        } else if (this.selectedPointCloudConf.loginMethod == WebshareAuthType.Sphere && this.companyInfo.intositeLoginMethod != IntositeLoginMethod.Sphere) {
          this.isPointCloudConfSelectEnabled = false;
          this.disabledWSLoginMethod = WebshareAuthType.Sphere;
        } else {
          this.isPointCloudConfSelectEnabled = true;
        }
      } else {
        this.isPointCloudConfSelectEnabled = true;
      }
    }
  }

  onChanges(): void { }
}
